import { render } from "./VisitDocumentsHosPal.vue?vue&type=template&id=2e04dbee&ts=true"
import script from "./VisitDocumentsHosPal.ts?vue&type=script&lang=ts&external"
export * from "./VisitDocumentsHosPal.ts?vue&type=script&lang=ts&external"

import "./VisitDocumentsHosPal.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__